"use client";

import { useEffect } from "react";
import { claimNotificationSession } from "../actions";

interface SessionClaimerProps {
  /** Signed account capability minted by the Nudge-link landing. */
  session: string;
}

/**
 * RSC render can't set cookies, so the order page hands the minted session
 * token to this component and it's redeemed into the `wgl_appt_auth` cookie
 * right after mount (idempotent — the action re-verifies the signature).
 */
export default function SessionClaimer({ session }: SessionClaimerProps) {
  useEffect(() => {
    void claimNotificationSession(session);
  }, [session]);
  return null;
}
